const months = {
  en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
}
export const monthsGenerator = (lang = 'en') => {
  return months[lang]
}
